<template>
  <div>
    <titulo-docentes-periodo />

    <hr class="my-3" />
    <strong class="d-block my-4">Dados da turma</strong>

    <div class="row">
      <div class="col-12 col-md-4">
        <input-select-search
          ref="anoLetivo"
          v-model="anoLetivoId"
          :label="$t('ACADEMICO.ANO_LETIVO')"
          placeholder="GERAL.DIGITE_OU_PROCURE"
          :options="opcoes.anoLetivo"
          required
        />
      </div>
      <div class="col-12 col-md-4">
        <input-select-search
          ref="turma"
          v-model="turmaId"
          :label="$t('ACADEMICO.TURMAS')"
          placeholder="GERAL.DIGITE_OU_PROCURE"
          :options="opcoes.turma"
          :isDisabled="desabilitados.turma"
          required
        />
      </div>
      <div class="col-12 col-md-4">
        <input-select-multiple
          ref="disciplinas"
          :label="$t('ACADEMICO.DISCIPLINAS')"
          v-model="disciplinaParaVinculo"
          placeholder="GERAL.DIGITE_OU_PROCURE"
          :options="opcoes.disciplinasFiltradas"
          :disabled="desabilitados.disciplina"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-button variant="primary" @click="imprimir" :disabled="!anoLetivoId">
          {{ $t('GERAL.IMPRIMIR_RELATORIO') }}
        </b-button>
      </div>
    </div>

    <hr class="my-3" />
    <strong class="d-block mb-4">Adicionar docentes a turma</strong>
    <div class="row pb-2">
      <div class="col-12 col-md-4">
        <InputSelectTyping
          ref="docenteId"
          v-model="docenteId"
          :label="$t('ACADEMICO.DOCENTES')"
          :options="opcoes.docente"
          required
          @pesquisa-nome="getDocentes"
          :loading="loadingDocentes"
          :isDisabled="desabilitados.docente"
        />
      </div>
      <div class="col-12 col-md-auto my-auto">
        <b-button
          class="w-100 btn-bootstrap-ajuste-mt"
          variant="primary"
          @click="adicionarDocente"
          :disabled="desabilitados.btnAdicionarDocente"
          v-if="podeCadastrar"
        >
          {{ $t('ACADEMICO.ADICIONAR_DOCENTE') }}
        </b-button>
      </div>
    </div>

    <tabela-docente
      :items="tabelaDocente"
      @remover="excluir"
      @alterar-ordenacao="novaOrdenacao"
    />
  </div>
</template>

<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';
import rotas from '@/common/utils/rotas';
import Permissoes from '@/components/mixins/permissoes';
import pdf from '@/common/utils/pdf';

// Services:
import AnoLetivoService from '@/common/services/anoLetivo/ano-letivo.service';
import PessoaService from '@/common/services/pessoa/pessoa.service';
import TurmasService from '@/common/services/academico/turma.service';
import DisciplinasService from '@/common/services/academico/disciplinas.service';

// Components:
import TabelaDocente from './components/TabelaDocente.vue';
import {
  InputSelectSearch,
  InputSelectMultiple,
  InputSelectTyping,
} from '@/components/inputs';
import TituloDocentesPeriodo from '@/views/academico/docentes-periodo/components/TituloDocentesPeriodo';

export default {
  mixins: [Permissoes],
  components: {
    InputSelectSearch,
    TabelaDocente,
    InputSelectMultiple,
    InputSelectTyping,
    TituloDocentesPeriodo,
  },
  data() {
    return {
      loadingDocentes: false,
      opcoes: {
        anoLetivo: [],
        turma: [],
        docente: [],
        disciplinasFiltradas: [],
      },
      docentesDaDisciplina: [],
      docentes: [],
      tabelaDocente: [],
      disciplinas: [],
      listagemTurmas: [],
      disciplinaParaVinculo: '',
      anoLetivoId: '',
      turmaId: '',
      docenteId: '',
      desabilitados: {
        turma: true,
        disciplina: true,
        docente: true,
        btnAdicionarDocente: true,
      },
      campoOrdenado: null,
      ordem: false,
    };
  },
  watch: {
    anoLetivoId: {
      handler: 'getTurma',
      immediate: true,
    },
    turmaId: {
      handler() {
        this.tabelaDocente = [];
        if (!this.turmaId) {
          this.opcoes.disciplinasFiltradas = [];
          this.desabilitados.disciplina = true;
          this.desabilitados.docente = true;
          this.opcoes.docente = [];
          this.docentesDaDisciplina = [];
        } else {
          this.desabilitados.disciplina = true;
          this.disciplinaParaVinculo = null;
          this.desabilitados.disciplina = false;
          this.desabilitados.docente = true;
          this.opcoes.docente = [];
          this.docentesDaDisciplina = [];
        }
        this.filtrarDisciplinasPorTurma();
      },
      immediate: true,
    },
    disciplinaParaVinculo: {
      handler() {
        this.docenteId = '';
        this.desabilitarCampo('btnAdicionarDocente');
        this.opcoes.docente = [];
        this.docentesDaDisciplina = [];

        if (this.disciplinaParaVinculo === null) {
          this.tabelaDocente = [];
          this.desabilitarCampo('docente');
          return;
        }
        this.habilitarCampo('docente');
        this.getDocentesIncluidosNoPeriodo();
        this.getDocentes();
      },
      immediate: true,
    },
    docenteId: {
      handler: 'habilitarBtnDocente',
    },
  },
  mounted() {
    this.getAnosLetivos();
  },
  methods: {
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
    habilitarCampo(campo) {
      this.desabilitados[campo] = false;
    },
    desabilitarCampo(campo) {
      this.desabilitados[campo] = true;
    },
    habilitarBtnDocente() {
      if (this.docenteId) this.desabilitados.btnAdicionarDocente = false;
    },
    excluir(item) {
      mensagem
        .confirmacao(null, this.$t(`Deseja remover docente ${item.item.nome}?`))
        .then(async (result) => {
          if (result.value && item.item.anoLetivoDocenteId) {
            await this.remover(item);
          }
        });
    },

    obterDisciplinaIdSelecionada() {
      return (
        this.disciplinaParaVinculo?.disciplina?.id ||
        this.disciplinaParaVinculo?.disciplinaId ||
        this.disciplinaParaVinculo?.id ||
        null
      );
    },
    getAnosLetivos() {
      this.$store.dispatch(START_LOADING);
      this.desabilitarCampo('btnAdicionarDocente');
      this.desabilitarCampo('docente');
      this.desabilitarCampo('turma');
      AnoLetivoService.listar()
        .then(({ data }) => {
          data = data.map((row) => ({
            ...data,
            text: row.ano,
            value: row.id,
          }));

          this.opcoes.anoLetivo = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    getTurma(id) {
      if (!id) return;
      this.turmaId = '';
      this.tabelaDocente = [];
      this.desabilitarCampo('disciplina');
      this.desabilitarCampo('btnAdicionarDocente');
      this.desabilitarCampo('docente');
      this.$store.dispatch(START_LOADING);
      TurmasService.buscarPorAnoLetivoId(id)
        .then(({ data }) => {
          this.listagemTurmas = data;
          this.disciplinas = data;
          if (data.length == 0) {
            data = [
              {
                value: null,
                text: 'Não existem turmas para o ano selecionado',
              },
            ];
          } else {
            data = data.map((row) => ({
              ...data,
              text: row.descricao,
              value: row.id,
            }));
          }
          this.opcoes.turma = data;
          this.habilitarCampo('turma');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    getDocentes() {
    this.desabilitarCampo('btnAdicionarDocente');
    this.loadingDocentes = true;

    const disciplinaId = this.obterDisciplinaIdSelecionada();

    if (!disciplinaId) {
      this.opcoes.docente = [];
      this.docentesDaDisciplina = [];
      this.loadingDocentes = false;
      return;
    }

    PessoaService.obterListaDocentes()
    .then((response) => {
      const docentes = response?.data ?? response;

      const options = (docentes || []).map((row) => ({
        ...row,
        text: row.nome,
        value: row.id,
        id: row.id,
        nome: row.nome,
      }));

      this.docentesDaDisciplina = options;
      this.opcoes.docente = this.filtrarDocentes(options);

      this.habilitarCampo('docente');
    })
    .catch((err) => {
      mensagem.showErrors(err);
      this.opcoes.docente = [];
      this.docentesDaDisciplina = [];
    })
    .finally(() => {
      this.loadingDocentes = false;
    });
  },

    getDocentesIncluidosNoPeriodo() {
      this.docenteId = null;
      this.$store.dispatch(START_LOADING);
      PessoaService.listarDocentesPorFiltro(
        this.disciplinaParaVinculo,
        this.anoLetivoId,
        this.turmaId,
        this.campoOrdenado,
        this.ordem
      )
        .then(({ data }) => {
          this.tabelaDocente = data;

          this.habilitarBtnDocente('btnAdicionarDocente');
          this.habilitarCampo('docente');

          if (this.docentesDaDisciplina?.length) {
            const options = this.docentesDaDisciplina.map((row) => ({
              ...row,
              text: row.nome,
              value: row.id,
            }));
            this.opcoes.docente = this.filtrarDocentes(options);
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },


    filtrarDisciplinasPorTurma() {
      this.disciplinaParaVinculo = null;
      if (!this.turmaId) return;

      const turmaSelecionada = this.disciplinas.filter(
        ({ id }) => String(id) === String(this.turmaId)
      );


      if (turmaSelecionada[0]?.disciplinas?.length === 0) {
        this.opcoes.disciplinasFiltradas = [
          {
            value: null,
            text: 'Sem disciplinas para turma selecionada',
          },
        ];
      } else {
        this.opcoes.disciplinasFiltradas =
          turmaSelecionada[0]?.disciplinas?.map((item) => ({
            ...item,
            value: item,
            text: `${item.codigo} - ${item.disciplinaDescricao}`,
          }));
      }
    },

    filtrarDocentes(data) {
      let docentesFiltrados = [];
      data.forEach((item, index) => {
        let resultado = [];
        this.tabelaDocente.forEach((item2) => {
          if (item2.id === item.value) {
            resultado.push({ ...item, index });
          }
        });
        if (index !== resultado[0]?.index) {
          docentesFiltrados.push(item);
        }
      });
      return docentesFiltrados;
    },

    async remover(item) {
      this.$store.dispatch(START_LOADING);
      AnoLetivoService.removerDocente(item.item)
        .then(({ data }) => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), data.mensagem);
          this.getDocentesIncluidosNoPeriodo();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    adicionarDocente() {
      this.$store.dispatch(START_LOADING);
      AnoLetivoService.adicionarDocente({
        disciplinaId: this.disciplinaParaVinculo?.disciplina.id,
        anoLetivoId: this.anoLetivoId,
        turmaId: this.turmaId,
        pessoaId: this.docenteId,
      })
        .then(({ data }) => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), data.mensagem);
          this.docenteId = '';
          this.desabilitarCampo('btnAdicionarDocente');
          this.getDocentesIncluidosNoPeriodo();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    irPara(rota, id) {
      rotas.irPara(rota, id);
    },

    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = ordem;
      this.getDocentesIncluidosNoPeriodo();
    },

    imprimir() {
      this.$store.dispatch(START_LOADING);
      DisciplinasService.imprimirRelatorioDocentes({
        anoLetivoId: this.anoLetivoId,
      })
        .then(({ data }) => {
          if (data.documento) {
            let bytes = pdf.base64ToArrayBuffer(data.documento);
            let blob = new Blob([bytes], { type: 'application/pdf' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = data.nomeArquivo;
            link.click();
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
};
</script>
